module.exports = __webpack_public_path__ + "img/picture_37.e15ccc3a.png";